// extracted by mini-css-extract-plugin
module.exports = {"element":"app-button_element_3WTB6","spinner":"app-button_spinner_1u_2J","rotate":"app-button_rotate_9ZnC8"};